// src/providers/segment.ts
import { Analytics } from "@segment/analytics-node";
var log = (prefix, client) => (...args) => (
  // eslint-disable-next-line no-console
  console.log(`%c[${client}:${prefix}]`, "color: #5c5cff", ...args)
);
var segmentStub = {
  identify: log("identify", "segment"),
  page: log("page", "segment"),
  track: log("track", "segment"),
  group: log("group", "segment")
};
var getSegmentInstance = (user, clientMode) => {
  if (import.meta.env.DEBUG_LOGGER || typeof import.meta.env.SEGMENT_WRITE_KEY === "undefined" || user.isSpoofing) {
    return segmentStub;
  }
  if (clientMode) {
    return window?.analytics;
  }
  return new Analytics({
    writeKey: import.meta.env.SEGMENT_WRITE_KEY,
    flushAt: 1
  });
};
var createSegmentClient = (user, clientMode = false) => {
  const { userId, accountId, email } = user;
  const segmentClient = getSegmentInstance(user, clientMode);
  const baseUserTraits = {
    env: import.meta.env.APPCUES_ENV,
    accountId,
    ...email && { email }
  };
  return {
    analyticsProvider: segmentClient,
    identify: ({ traits = {}, context = {}, identifyUserId }) => {
      const identifyProps = {
        userId: identifyUserId || userId,
        traits: {
          ...baseUserTraits,
          ...traits
        },
        context
      };
      if (clientMode) {
        segmentClient?.identify(userId, identifyProps);
      } else {
        segmentClient?.identify(identifyProps);
      }
    },
    group: ({ traits = {}, context = {} } = {}) => {
      const groupProps = {
        userId,
        groupId: accountId,
        traits: {
          ...baseUserTraits,
          ...traits
        },
        context
      };
      if (clientMode) {
        segmentClient?.group(accountId, groupProps);
      } else {
        segmentClient?.group(groupProps);
      }
    },
    page: () => {
      segmentClient?.page({
        userId,
        traits: {
          ...baseUserTraits
        }
      });
    },
    track: (properties = {}) => {
      segmentClient?.track({
        userId,
        event: properties.name,
        properties: {
          ...baseUserTraits,
          ...properties
        },
        context: {
          groupId: accountId
        }
      });
    }
  };
};

export {
  createSegmentClient
};
//# sourceMappingURL=chunk-QN7COP2I.mjs.map